export default __webpack_public_path__ + "static/media/plus-icon.f4d93a41.svg";